import { Login, GuestToken } from '@/apis/comm/api'
import { useToken, useInfoUser } from '@/hooks/storage'
import { createRouter, createWebHistory, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import { getUserInfo } from '@/apis/comm/api'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: {
      title: '校外车辆入校预约'
    }
  },
  {
    path: '/school',
    name: 'School',
    component: () => import('../views/school.vue'),
    meta: {
      title: '校外车辆入校预约-校内教职工申请入口'
    }
  },
  {
    path: '/pub',
    name: 'Pub',
    redirect: 'pub/index',
    children: [
      {
        path: 'index',
        name: 'pubIndex',
        component: () => import('../views/public/Register.vue'),
        meta: {
          title: '校外车辆入校预约（因公）'
        }
      },
      {
        path: 'apply',
        name: 'pubApply',
        component: () => import('../views/public/Applyfor.vue'),
        meta: {
          title: '校外车辆入校预约（因公）'
        }
      },
      {
        path: 'approve',
        name: 'pubApprove',
        component: () => import('../views/public/Approve.vue'),
        meta: {
          title: '校外车辆入校预约（因公）审批'
        }
      },
      {
        path: 'approvem',
        name: 'pubApprovem',
        component: () => import('../views/public/Approvem.vue'),
        meta: {
          title: '校外车辆入校预约（因公）审批'
        }
      },
      {
        path: 'report',
        name: 'pubReport',
        component: () => import('../views/public/Report.vue'),
        meta: {
          title: '校外车辆入校预约（因公）'
        }
      },
      {
        path: 'detail',
        name: 'pubdetail',
        component: () => import('../views/public/detail.vue'),
        meta: {
          title: '校外车辆入校预约（因公）'
        }
      }
    ]
  },
  {
    path: '/pri',
    name: 'Pri',
    redirect: 'pri/index',
    children: [
      {
        path: 'index',
        name: 'priIndex',
        component: () => import('../views/private/Register.vue'),
        meta: {
          title: '校外车辆入校预约（因私）'
        }
      },
      {
        path: 'apply',
        name: 'priApply',
        component: () => import('../views/private/Applyfor.vue'),
        meta: {
          title: '校外车辆入校预约（因私）'
        }
      },
      {
        path: 'approve',
        name: 'priApprove',
        component: () => import('../views/private/Approve.vue'),
        meta: {
          title: '校外车辆入校预约（因私）审批'
        }
      },
      {
        path: 'approvem',
        name: 'priApprovem',
        component: () => import('../views/private/Approvem.vue'),
        meta: {
          title: '校外车辆入校预约（因私）审批'
        }
      },
      {
        path: 'report',
        name: 'priReport',
        component: () => import('../views/private/Report.vue'),
        meta: {
          title: '校外车辆入校预约（因私）'
        }
      },
      {
        path: 'detail',
        name: 'pubDetail',
        component: () => import('../views/private/detail.vue'),
        meta: {
          title: '校外车辆入校预约（因私）'
        }
      }
    ]
  },
  {
    path: '/401',
    name: '401',
    component: () => import('../views/error/401.vue')
  },
  {
    path: '/error',
    name: 'error',
    component: () => import('../views/error/401.vue')
  },
  {
    path: '/500',
    name: '500',
    component: () => import('../views/error/500.vue')
  },
  {
    path: '/*',
    name: '*',
    component: () => import('../views/error/404.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

let publicPage = ['/pub/approve', '/pub/approvem']
let privatePage = ['/pri/approve', '/pri/approvem']
router.beforeEach(async (to, from, next) => {
  if (to.query.token) {
    useToken().set(to.query.token)
    const { data } = await getUserInfo()
    useInfoUser().set(JSON.stringify(data.data.user))
  }
  if (to.path === '/public') {
    window.location.href = (window as any).VUE_APP_BASE_URL + '/redirectReportToPC/public'
  }
  if (to.path === '/private') {
    window.location.href = (window as any).VUE_APP_BASE_URL + '/redirectReportToPC/private'
  }
  if (publicPage.includes(to.path)) {
    let isTrue = (window.innerWidth > 800 && to.path == '/pub/approve') || (window.innerWidth < 800 && to.path == '/pub/approvem')
    if (!isTrue) {
      if (window.innerWidth > 800) {
        next({ path: '/pub/approve', query: to.query })
      } else {
        next({ path: '/pub/approvem', query: to.query })
      }
    } else {
      next()
    }
  }
  if (privatePage.includes(to.path)) {
    let isTrue = (window.innerWidth > 800 && to.path == '/pri/approve') || (window.innerWidth < 800 && to.path == '/pri/approvem')
    if (!isTrue) {
      if (window.innerWidth > 800) {
        next({ path: '/pri/approve', query: to.query })
      } else {
        next({ path: '/pri/approvem', query: to.query })
      }
    } else {
      next()
    }
  }
  next()
  document.title = (to.meta.title as string) || ''
})

export default router
